import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ClipboardList, Download, AlertCircle, Loader2 } from 'lucide-react';

export function ClientFormsTab({ forms, selectedForm, setSelectedForm, generating, onGenerate }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <ClipboardList className="w-5 h-5 text-primary" />
          Generate Pre-Filled Forms
        </CardTitle>
        <CardDescription>Download immigration forms pre-filled with your information</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <Select value={selectedForm} onValueChange={setSelectedForm}>
              <SelectTrigger data-testid="form-select">
                <SelectValue placeholder="Select a form..." />
              </SelectTrigger>
              <SelectContent>
                {forms.map(form => (
                  <SelectItem key={form.id} value={form.id}>{form.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button onClick={onGenerate} disabled={generating || !selectedForm} className="w-full" data-testid="generate-form-btn">
            {generating ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Download className="w-4 h-4 mr-2" />}
            Download Form
          </Button>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
          <div className="flex gap-3">
            <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0" />
            <div>
              <p className="font-body text-sm font-medium text-amber-800">Complete Your Profile First</p>
              <p className="font-body text-xs text-amber-700">
                For best results, complete all profile information before generating forms. Missing information will be left blank on the forms.
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
